import React from 'react';
import {PropTypes} from 'prop-types';
import {Button, Flex, Icon, Text} from '@spothero/ui';
import {
    ChevronLeft as IconChevronLeft,
    ChevronRight as IconChevronRight,
} from '@spothero/icons';
import dayjs from 'dayjs';

const DatePickerHeader = ({
    date,
    nextMonthButtonDisabled,
    prevMonthButtonDisabled,
    decreaseMonth,
    increaseMonth,
}) => {
    const monthYear = dayjs(date).format('MMMM YYYY');

    return (
        <Flex justify="center" paddingX="3.5" alignItems="center">
            <Button
                variant="tertiary"
                disabled={prevMonthButtonDisabled}
                onClick={decreaseMonth}
                data-testid="DatePickerHeader-prev-month-button"
                border="none"
            >
                <Icon
                    as={IconChevronLeft}
                    width={3.5}
                    height={3.5}
                    data-testid="DatePickerHeader-left-chevron-icon"
                />
            </Button>
            <Text
                fontWeight="semibold"
                fontSize="lg"
                data-testid="DatePickerHeader-month-year-text"
                alignSelf="center"
                paddingX=".5rem"
            >
                {monthYear}
            </Text>
            <Button
                variant="tertiary"
                disabled={nextMonthButtonDisabled}
                onClick={increaseMonth}
                data-testid="DatePickerHeader-next-month-button"
                border="none"
            >
                <Icon
                    as={IconChevronRight}
                    width={3.5}
                    height={3.5}
                    data-testid="DatePickerHeader-right-chevron-icon"
                />
            </Button>
        </Flex>
    );
};

DatePickerHeader.propTypes = {
    date: PropTypes.object,
    nextMonthButtonDisabled: PropTypes.bool,
    prevMonthButtonDisabled: PropTypes.bool,
    decreaseMonth: PropTypes.func,
    increaseMonth: PropTypes.func,
};
export default DatePickerHeader;
